import classNames from 'classnames';
import React, {useCallback} from 'react';

import * as biojs from 'BioJS';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as sequtil from 'molbio/SeqUtil';
import {PreviewProps} from 'notebook/notes/previews/PreviewMixin';
import usePreviewMixin from 'notebook/notes/previews/usePreviewMixin';
import {NoteLinkedAnnotation} from 'notebook/util/NoteUtilConstants';

const {modelRangeToDisplay} = sequtil;

export default function AnnotationPreview(props: PreviewProps): JSX.Element {
  const {item} = props;
  const renderItem = useCallback(() => {
    // @ts-expect-error(2322)
    const annotation: NoteLinkedAnnotation = item;
    const [start, end] = Array.from(
      modelRangeToDisplay(
        annotation.start,
        annotation.end,
        annotation.sequenceLength,
        annotation.sequenceStartIndex
      )
    );
    return (
      <div>
        <div className="note-preview-body">
          <div className="note-preview-drawing">
            <div className="location-start">{start}</div>
            <div
              className={classNames({
                'annotation-render': true,
                reversed: annotation.strand === -1,
              })}
            >
              <div className="annotation-body" style={{backgroundColor: annotation.color}} />
              <div className="annotation-right-end" style={{borderLeftColor: annotation.color}} />
            </div>
            <div className="location-end">{end}</div>
          </div>
        </div>
        <dl className="dl-horizontal">
          <dt>Length</dt>
          <dd>
            {
              // @ts-expect-error(2339): Unclear if this should be sequenceLength
              biojs.util.formatBaseCount(annotation.length)
            }
          </dd>
          <dt>Type</dt>
          <dd>{annotation.annotation_type || 'None'}</dd>
        </dl>
      </div>
    );
  }, [item]);

  const {render} = usePreviewMixin({
    ...props,
    className: 'note-annotation',
    noteType: ModelTypeConstants.ANNOTATION,
    renderItem,
  });
  return render();
}
